class UspFreeShipping extends HTMLElement {
  connectedCallback() {
    this.initializeSlider();

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.refreshCartState();
    });
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }

  async refreshCartState() {
    const requestId = (this.requestId || 0) + 1;
    this.requestId = requestId;

    try {
      const response = await fetch(routes.cart_url + '.js');
      if (!response.ok) return;

      const cart = await response.json();
      if (requestId !== this.requestId) return;
      this.updateCartState(cart);
    } catch (error) {
      // Keep the last rendered state if the cart request fails.
    }
  }

  updateCartState(cart) {
    const progress = this.querySelector('[data-free-shipping-progress]');
    const progressState = this.querySelector('[data-usp-shipping-progress]');
    const defaultState = this.querySelector('[data-usp-default-content]');
    if (!progress || !progressState || !defaultState) return;

    const threshold = Number(progress.dataset.threshold);
    const total = Number(cart.total_price) || 0;
    const remaining = Math.max(threshold - total, 0);
    const showShippingProgress = total > 0 && remaining > 0;

    progressState.hidden = !showShippingProgress;
    defaultState.hidden = showShippingProgress;
    defaultState.classList.toggle('is-cart-empty', total === 0);
    defaultState.classList.toggle('is-free-shipping-unlocked', total >= threshold);

    const message = progress.querySelector('[data-free-shipping-message]');
    const bar = progress.querySelector('[data-free-shipping-bar]');
    if (message && bar) {
      bar.style.width = Math.min((total / threshold) * 100, 100) + '%';
      message.textContent = remaining
        ? 'You’re ' +
          new Intl.NumberFormat(document.documentElement.lang, {
            style: 'currency',
            currency: cart.currency,
          }).format(remaining / 100) +
          ' away from free shipping.'
        : 'Your order is eligible for free delivery! Yay!';
    }

    if (!showShippingProgress) this.initializeSlider();
  }

  initializeSlider() {
    const list = this.querySelector('.usp-bar__list');
    if (!list || !window.jQuery?.fn?.slick || this.querySelector('[data-usp-default-content]')?.hidden) return;

    const $list = window.jQuery(list);
    if ($list.hasClass('slick-initialized')) {
      $list.slick('setPosition');
      return;
    }

    $list.slick({
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      vertical: true,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
  }
}

if (!customElements.get('usp-free-shipping')) {
  customElements.define('usp-free-shipping', UspFreeShipping);
}
